var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { "align-center": "", "justify-center": "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.screen.loading,
                      expression: "screen.loading"
                    }
                  ],
                  attrs: {
                    width: "100%",
                    "max-width": "800px",
                    elevation: "24"
                  }
                },
                [
                  _c(
                    "v-container",
                    { staticStyle: { height: "400px" } },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "fill-height",
                          attrs: {
                            "align-content": "center",
                            justify: "center"
                          }
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-subtitle-1 text-center",
                              attrs: { cols: "12" }
                            },
                            [_vm._v(" Verificando Permissão ")]
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "7" } },
                            [
                              _c("v-progress-linear", {
                                attrs: {
                                  color: "deep-purple accent-4",
                                  indeterminate: "",
                                  rounded: "",
                                  height: "6"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.screen.error,
                      expression: "screen.error"
                    }
                  ],
                  attrs: {
                    width: "100%",
                    "max-width": "800px",
                    elevation: "24"
                  }
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-alert",
                        { attrs: { outlined: "", color: "error" } },
                        [
                          _c("div", { staticClass: "text-h6 mb-3" }, [
                            _vm._v(" Erro na Redefinição da Senha ")
                          ]),
                          _c("div", { staticClass: "mb-3" }, [
                            _vm._v(
                              " Não foi possível concluir a alteração solicitada. A chave informada está expirada ou é inválida. "
                            )
                          ]),
                          _c("div", { staticClass: "mb-3" }, [
                            _vm._v(
                              " Por favor, solicite a redefinição da senha novamente, para envio de nova chave. "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "default" },
                          on: { click: _vm.returnElection }
                        },
                        [_vm._v(" OK ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.screen.success,
                      expression: "screen.success"
                    }
                  ],
                  attrs: {
                    width: "100%",
                    "max-width": "800px",
                    elevation: "24"
                  }
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-alert",
                        { attrs: { outlined: "", color: "success" } },
                        [
                          _c("div", { staticClass: "text-h6 mb-2" }, [
                            _vm._v(" A Senha foi alterada com sucesso. ")
                          ]),
                          _c("div", { staticClass: "mb-2" }, [
                            _vm._v(
                              " Tente fazer login na urna online com a nova senha. "
                            )
                          ]),
                          _c("div", { staticClass: "mb-2" }, [
                            _vm._v(
                              " Caso não consiga, faça uma nova solicitação. "
                            )
                          ]),
                          _c("div", [
                            _vm._v(
                              " Para voltar para a tela de login, clique no botão abaixo "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "default" },
                          on: { click: _vm.returnElection }
                        },
                        [_vm._v(" OK ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.screen.password,
                      expression: "screen.password"
                    }
                  ],
                  attrs: {
                    width: "100%",
                    "max-width": "800px",
                    elevation: "24"
                  }
                },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { flat: "", color: "primary-color" } },
                    [
                      _c("v-toolbar-title", [
                        _vm._v(" Redefinir senha de eleitor ")
                      ]),
                      _c("v-spacer"),
                      _c("v-tooltip", { attrs: { right: "" } }, [void 0], 2)
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        { ref: "frmPRE" },
                        [
                          _c("v-text-field", {
                            attrs: {
                              "append-icon": _vm.tfp.one.icon,
                              type: _vm.tfp.one.type,
                              label: "Digite sua nova senha",
                              hint: "mínimo de 6 caracteres",
                              rules: [_vm.rules.required, _vm.rules.min]
                            },
                            on: {
                              "click:append": function($event) {
                                _vm.tfp.one.show = !_vm.tfp.one.show
                              }
                            },
                            model: {
                              value: _vm.tfp.one.value,
                              callback: function($$v) {
                                _vm.$set(_vm.tfp.one, "value", $$v)
                              },
                              expression: "tfp.one.value"
                            }
                          }),
                          _c("v-text-field", {
                            attrs: {
                              "append-icon": _vm.tfp.two.icon,
                              type: _vm.tfp.two.type,
                              label: "Confirme sua nova senha",
                              rules: [_vm.validatePassword]
                            },
                            on: {
                              "click:append": function($event) {
                                _vm.tfp.two.show = !_vm.tfp.two.show
                              }
                            },
                            model: {
                              value: _vm.tfp.two.value,
                              callback: function($$v) {
                                _vm.$set(_vm.tfp.two, "value", $$v)
                              },
                              expression: "tfp.two.value"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.btnLoading,
                            disabled: _vm.btnLoading,
                            outlined: ""
                          },
                          on: { click: _vm.btnSave }
                        },
                        [_vm._v(" Salvar ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            disabled: _vm.btnLoading,
                            outlined: ""
                          },
                          on: { click: _vm.returnElection }
                        },
                        [_vm._v(" Cancelar ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }